module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/translates/cat/CabalTemp.json
// module id = 584
// module chunks = 1